// extracted by mini-css-extract-plugin
export default {"center_box":"index_center_box_m6vN7","adBox":"index_adBox_0Yw7a"};